
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/compliance",
      function () {
        return require("private-next-pages/services/compliance.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/compliance"])
      });
    }
  